import { render } from "./header2.vue?vue&type=template&id=08b03fa8&scoped=true"
import script from "./header2.vue?vue&type=script&lang=js"
export * from "./header2.vue?vue&type=script&lang=js"

import "./header2.vue?vue&type=style&index=0&id=08b03fa8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08b03fa8"]])

export default __exports__